// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwTextbox from 'viewmodel/AwTextboxViewModel';
import AwTextarea from 'viewmodel/AwTextareaViewModel';
import AwNumeric from 'viewmodel/AwNumericViewModel';
import AwLabel from 'viewmodel/AwLabelViewModel';
import AwFileUpload from 'viewmodel/AwFileUploadViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
    import { EnableWhen } from 'js/hocCollection';
const AwButtonEnableWhen = EnableWhen(AwButton);
AwButtonEnableWhen.displayName = 'AwButtonEnableWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desUpdateLibraryService', () => import('js/desUpdateLibraryService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "imports": [],
    "lifecycleHooks": {
        "onUpdate": {
            "observers": [
                "props.accsessionid",
                "props.parentFolder",
                "props.libraryId"
            ]
        }
    },
    "data": {
        "name": {
            "displayName": "{{i18n.name}}",
            "type": "STRING",
            "isRequired": "true",
            "isEditable": "true",
            "dbValue": "",
            "dispValue": ""
        },
        "description": {
            "displayName": "{{i18n.description}}",
            "type": "STRING",
            "isRequired": "true",
            "isEditable": "true",
            "dbValue": " ",
            "dispValue": " ",
            "numberOfLines": 3
        },
        "number": {
            "displayName": "{{i18n.number}}",
            "type": "INTEGER",
            "isRequired": "true",
            "isEditable": "true",
            "dbValue": "",
            "dispValue": ""
        },
        "revisionId": {
            "displayName": "{{i18n.revisionId}}",
            "type": "INTEGER",
            "isRequired": "true",
            "isEditable": "true",
            "dbValue": "",
            "dispValue": ""
        },
        "image": {
            "displayName": "{{i18n.image}}",
            "type": "STRING"
        },
        "attachments": {
            "displayName": "{{i18n.attachments}}",
            "type": "STRING"
        }
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "parentFolder": {
            "type": "string"
        },
        "libraryId": {
            "type": "string"
        }
    },
    "actions": {
        "createLibraryComponent": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {},
                        "query": "mutation CreateLibraryComponent( $libraryId: String, $parentFolder: String, $createLibraryComponentInput: CreateLibraryComponentInput) {createLibraryComponent( libraryId: $libraryId, parentFolder: $parentFolder, createLibraryComponentInput: $createLibraryComponentInput )}",
                        "variables": {
                            "libraryId": "props.libraryId",
                            "parentFolder": "props.parentFolder",
                            "createLibraryComponentInput": {
                                "properties": {
                                    "name": "{{data.name.dbValue}}",
                                    "description": "{{data.description.dbValue}}",
                                    "number": "{{data.number.dbValue}}",
                                    "revisionId": "{{data.revisionId.dbValue}}"
                                },
                                "attachments": "{{data.filename.dbValue}}",
                                "typeName": "Catalog.Part"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "createdLibraryComponent": "data.data.CreateLibraryComponent"
            },
            "events": {
                "failure": [
                    {
                        "name": "desLibraryComponentFailure",
                        "eventData": {
                            "eventData": "{{createdLibraryComponent}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "desLibraryComponentSuccess",
                        "eventData": {
                            "eventName": "desLibraryComponentSuccess",
                            "eventData": "{{createdLibraryComponent}}"
                        }
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "updateSelectedFileInfoAction": {
            "actionType": "JSFunction",
            "method": "getSelectedFileInfo",
            "inputData": {
                "fileName": "{{parameters.fileName}}",
                "fileNameNoExt": "{{parameters.fileNameNoExt}}",
                "fileExt": "{{parameters.fileExt}}",
                "formData": "{{parameters.formData}}",
                "data": "{{data}}"
            },
            "outputData": {
                "dataToBeRelated": "dataToBeRelated",
                "fileInputForms": "fileInputForms"
            },
            "deps": "js/desUpdateLibraryService"
        },
        "uploadThumbnail": {
            "actionType": "JSFunction",
            "method": "uploadFileByTicket",
            "inputData": {
                "thumbnailTicket": "{{parameters.eventData.thumbnailUploadTicket}}",
                "formData": "{{fileInputForms}}"
            }
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/accEventBus"
        }
    },
    "onEvent": [
        {
            "eventId": "desLibraryComponentSuccess",
            "message": "displayDesCreateLibraryComponentSuccessMsg",
            "action": "uploadThumbnail",
            "inputArgs": {
                "eventName": "{{eventData.eventName}}",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "desLibraryComponentFailure",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "desLibraryComponentFailure",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "invalidFileSelected",
            "message": "invalidFileError"
        }
    ],
    "messages": {
        "displayDesCreateLibraryComponentSuccessMsg": {
            "messageType": "INFO",
            "messageText": "{{i18n.libraryComponentSuccessMsg}}"
        },
        "invalidFileError": {
            "messageType": "WARNING",
            "messageText": "{{i18n.invalidFileError}}",
            "navigationOptions": [
                {
                    "option": "Cancel",
                    "text": "{{i18n.CancelText}}"
                }
            ]
        }
    },
    "conditions": {
        "enableAddButton": {
            "expression": "data.name.dbValue && data.description.dbValue && data.number.dbValue && data.revisionId.dbValue"
        }
    },
    "i18n": {
        "buttonDemoComponent": [
            "DesLibraryMessages"
        ],
        "name": [
            "DesLibraryMessages"
        ],
        "description": [
            "DesLibraryMessages"
        ],
        "number": [
            "DesLibraryMessages"
        ],
        "revisionId": [
            "DesLibraryMessages"
        ],
        "image": [
            "DesLibraryMessages"
        ],
        "attachments": [
            "DesLibraryMessages"
        ],
        "invalidFileError": [
            "DesLibraryMessages"
        ],
        "addButton": [
            "DesLibraryMessages"
        ],
        "libraryComponentSuccessMsg": [
            "DesLibraryMessages"
        ]
    },
    "_viewModelId": "DesCreateLibraryComponent",
    "_uniqueViewModelId": "DesCreateLibraryComponent",
    "ctx": {}
};

    /*
    <aw-panel>
    <aw-panel-body>
        <aw-textbox prop="data.name"></aw-textbox>
        <aw-textarea prop="data.description"></aw-textarea>
        <aw-numeric prop="data.number"></aw-numeric>
        <aw-numeric prop="data.revisionId"></aw-numeric>
        <aw-label prop="data.image"></aw-label>
        <aw-file-upload type-filter=".png, .gif, .jpg, .jpeg" file-change-action="updateSelectedFileInfoAction">
        </aw-file-upload>
        <aw-label prop="data.attachments"></aw-label>
        <aw-file-upload type-filter=".pdf,.jt,.stp,.dxf,.prt" file-change-action="updateSelectedFileInfoAction">
        </aw-file-upload>
    </aw-panel-body>
    <aw-panel-footer>
        <aw-button class="small" button-type="accent-high-contrast" size="stretched" action="createLibraryComponent"
            enable-when="conditions.enableAddButton">{{i18n.addButton}}</aw-button>
    </aw-panel-footer>
</aw-panel>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}>
        <AwPanelBody>
            <AwTextbox {...getField("data.name", fields, $index, null, null )}>
            </AwTextbox>
            <AwTextarea {...getField("data.description", fields, $index, null, null )}>
            </AwTextarea>
            <AwNumeric {...getField("data.number", fields, $index, null, null )}>
            </AwNumeric>
            <AwNumeric {...getField("data.revisionId", fields, $index, null, null )}>
            </AwNumeric>
            <AwLabel {...getField("data.image", fields, $index, null, null )}>
            </AwLabel>
            <AwFileUpload dndHandler={props.viewModel.dndHandler} typeFilter=".png, .gif, .jpg, .jpeg" fileChangeAction={actions.updateSelectedFileInfoAction}>
            </AwFileUpload>
            <AwLabel {...getField("data.attachments", fields, $index, null, null )}>
            </AwLabel>
            <AwFileUpload dndHandler={props.viewModel.dndHandler} typeFilter=".pdf,.jt,.stp,.dxf,.prt" fileChangeAction={actions.updateSelectedFileInfoAction}>
            </AwFileUpload>
        </AwPanelBody>
        <AwPanelFooter>
            <AwButtonEnableWhen className="small" buttonType="accent-high-contrast" size="stretched" action={actions.createLibraryComponent} enableWhen={AwParseService.instance( "conditions.enableAddButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                {AwParseService.instance( "i18n.addButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
            </AwButtonEnableWhen>
        </AwPanelFooter>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;